import { render, staticRenderFns } from "./LoginGoogleButton.vue?vue&type=template&id=20e9924d&"
import script from "./LoginGoogleButton.vue?vue&type=script&lang=ts&"
export * from "./LoginGoogleButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoginGoogleButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports